import login from './login';
import password from './password';
import activate from './activate';
import confirmEmail from './confirmEmail';

export const customSagas = [...login, ...password, ...activate, ...confirmEmail];
